"use client";

import { Menu, X } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useState } from "react";

import { useCheckout } from "@/lib/hooks/use-checkout";
import { cn } from "@/lib/utils";

export function NavV2() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { loadingPlan, start } = useCheckout("landing_nav");

  return (
    <nav className="sticky top-0 z-40 border-b border-slate-100/80 bg-white/85 backdrop-blur-md">
      <div className="mx-auto flex h-20 max-w-6xl items-center justify-between gap-6 px-6">
        <Link href="/" className="flex items-center">
          <Image
            src="/funnlr_logo.png"
            alt="Funnlr"
            width={200}
            height={48}
            className="h-30 w-auto"
            priority
          />
        </Link>

        <div className="hidden items-center gap-7 md:flex">
          <a
            href="/#features"
            className="text-[13px] font-medium text-slate-600 transition-colors hover:text-slate-900"
          >
            Features
          </a>
          <a
            href="/#pricing"
            className="text-[13px] font-medium text-slate-600 transition-colors hover:text-slate-900"
          >
            Pricing
          </a>
          <a
            href="/#how-it-works"
            className="text-[13px] font-medium text-slate-600 transition-colors hover:text-slate-900"
          >
            How it works
          </a>
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            href="/sign-in"
            className="text-[13px] font-medium text-slate-600 transition-colors hover:text-slate-900"
          >
            Sign in
          </Link>
          <button
            onClick={() => start("lifetime")}
            disabled={loadingPlan !== null}
            className={cn(
              "inline-flex h-9 items-center gap-1.5 rounded-full bg-gradient-brand px-4 text-[12.5px] font-semibold text-white shadow-glow transition-all hover:bg-gradient-brand-hover hover:shadow-glow-hover disabled:opacity-60",
            )}
          >
            {loadingPlan === "lifetime" ? "Redirecting…" : "Get Lifetime · £67"}
          </button>
        </div>

        <button
          className="p-2 text-slate-600 md:hidden"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? (
            <X className="h-5 w-5" />
          ) : (
            <Menu className="h-5 w-5" />
          )}
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-slate-100 bg-white px-6 pb-5 pt-3 md:hidden">
          <div className="flex flex-col gap-2">
            <a
              href="/#features"
              onClick={() => setMobileOpen(false)}
              className="py-1.5 text-sm font-medium text-slate-600"
            >
              Features
            </a>
            <a
              href="/#pricing"
              onClick={() => setMobileOpen(false)}
              className="py-1.5 text-sm font-medium text-slate-600"
            >
              Pricing
            </a>
            <a
              href="/#how-it-works"
              onClick={() => setMobileOpen(false)}
              className="py-1.5 text-sm font-medium text-slate-600"
            >
              How it works
            </a>
            <Link
              href="/sign-in"
              onClick={() => setMobileOpen(false)}
              className="py-1.5 text-sm font-medium text-slate-600"
            >
              Sign in
            </Link>
            <button
              onClick={() => {
                setMobileOpen(false);
                start("lifetime");
              }}
              disabled={loadingPlan !== null}
              className="mt-2 inline-flex h-10 items-center justify-center rounded-full bg-gradient-brand px-4 text-[13px] font-semibold text-white shadow-glow"
            >
              {loadingPlan === "lifetime"
                ? "Redirecting…"
                : "Get Lifetime · £67"}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
